<section class="login-section">
    <div class="login-container">
        <div class="login-card">
            <div class="logo-container">
                <img src="../../../assets/img/logo_alcaldia_vertical.jpeg" alt="Logo" class="logo-img">
            </div>
            <!-- <div class="img"></div> -->
            <div class="login-content">
                <h4 class="login-title">MiMUNICIPIO</h4>
                <p class="login-subtitle">R.R.H.H</p>

                <!-- Formulario -->
                <form (submit)="onSubmit()" autocomplete="off" class="login-form">
                <div class="campo-login">
                   <label class="label-login">
                    Ingrese su nombre de usuario<span class="asterisco">*</span>
                   </label>
                     <mat-form-field appearance="outline" class="full-width">
        <input class="custom-input" matInput placeholder="Ingrese su nombre de usuario"
            [(ngModel)]="username" name="username" required />
    </mat-form-field>
</div>

         <div class="campo-login">
            <label class="label-login">
            Ingrese su contraseña<span class="asterisco">*</span>
            </label>
              <mat-form-field appearance="outline" class="full-width">
                 <input class="custom-input" matInput [type]="hidePassword ? 'password' : 'text'"
               [(ngModel)]="password" name="password" placeholder="Ingrese su contraseña" required />
        <button type="button" mat-icon-button matSuffix (click)="togglePasswordVisibility()"
            [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePassword">
            <mat-icon class="icon-toggle">{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
    </mat-form-field>
</div>
                    <!-- Mensaje de error -->
                    <mat-error *ngIf="errorMessage">{{ errorMessage }}</mat-error>

                    <div class="form-actions">
                        <button class="custom-button" mat-raised-button color="primary" type="submit">Ingresar</button>
                    </div>

                    <div>
                        <br />
                        <input type="checkbox" class="checkbox">
                        <label for="login-check" class="login__check-label">Recordarme nombre de
                            usuario</label>
                    </div>
                </form>
            </div>
        </div>
        <p class="version-info">2024 - Versión 3.0.0</p>
    </div>
</section>